import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { fetchMyRequests } from "../utils/matchingApi";

/** Roles that own trucks (matching GET /truck/* answers 403 to everyone else). */
// DISPATCHER too: a dispatcher manages vehicles (wireframes; ТЗ §10 «диспетчер ТК включает машину от имени водителя»)
export const CARRIER_ROLES = ["DRIVER", "COMPANY", "DISPATCHER", "ADMIN"];
export const isCarrierRole = (role) => CARRIER_ROLES.includes(role);

// Tiny shared store: the topbar badge (CabShell) and the pages that change request
// state (Fleet / Notifications) stay in sync through setUnreadCount().
let count = 0;
let override = null; // set by the Notifications page: its total unread (requests + offers on my loads)
const listeners = new Set();
const shown = () => (override != null ? override : count);
const emit = () => listeners.forEach((fn) => fn(shown()));
/** Unread = a request nobody answered and nobody opened yet (same rule as the Notifications «Новые» tab). */
export const countUnread = (matches = []) => matches.filter((m) => !m.decided && !m.viewed).length;
export const setUnreadCount = (n) => {
  const v = Number(n) || 0;
  if (v === count) return;
  count = v;
  emit();
};
export const setUnreadOverride = (n) => {
  override = n == null ? null : Number(n) || 0;
  emit();
};

const POLL_MS = 30_000;
let inflight = false;
let currentRole = null;
export async function refreshUnread() {
  if (inflight) return;
  inflight = true;
  try {
    const API = process.env.REACT_APP_API_URL;
    const headers = { Authorization: `JWT ${window.localStorage.getItem("access")}` };
    let dismissed = new Set();
    try {
      dismissed = new Set(JSON.parse(localStorage.getItem("cab_dismissed_notices") || "[]"));
    } catch {
      /* ignore */
    }
    const [feed, sys, prefs] = await Promise.allSettled([
      isCarrierRole(currentRole) ? fetchMyRequests() : Promise.resolve(null),
      axios.get(`${API}/auth/notifications/`, { headers }),
      axios.get(`${API}/auth/preferences/`, { headers }),
    ]);
    const p = prefs.status === "fulfilled" ? prefs.value.data : {};
    let n = 0;
    if (feed.status === "fulfilled" && p.notify_requests !== false) {
      n += countUnread((feed.value?.matches || []).filter((m) => !dismissed.has(`m:${m.match_id}`)));
    }
    if (sys.status === "fulfilled" && p.notify_system !== false) {
      n += (sys.value.data || []).filter((x) => !x.is_read && !dismissed.has(`s:${x.id}`)).length;
    }
    setUnreadCount(n);
  } catch {
    /* keep last value */
  } finally {
    inflight = false;
  }
}

/** Real count of undecided incoming requests for the topbar bell. */
export default function useUnread() {
  const role = useSelector((s) => s.auth.user?.role);
  const [n, setN] = useState(shown());
  useEffect(() => {
    listeners.add(setN);
    setN(shown());
    return () => listeners.delete(setN);
  }, []);
  useEffect(() => {
    currentRole = role;
    if (!role) return undefined;
    refreshUnread();
    const t = setInterval(() => document.visibilityState === "visible" && refreshUnread(), POLL_MS);
    return () => clearInterval(t);
  }, [role]);
  return n;
}
